import React, { useState } from 'react';
import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Textarea } from '../ui/textarea';
import { ChevronDown, ChevronUp, Utensils } from 'lucide-react';

const FIELDS = [
  { key: 'dietaryVegan', label: 'Vegan' },
  { key: 'dietaryVegetarian', label: 'Vegetarian' },
  { key: 'dietaryGlutenFree', label: 'Gluten-Free' },
  { key: 'dietaryNutAllergy', label: 'Nut Allergy' },
  { key: 'dietaryDairyFree', label: 'Dairy-Free' },
  { key: 'dietaryHalal', label: 'Halal' },
  { key: 'dietaryKosher', label: 'Kosher' },
];

const DietarySection = ({ formData, setFormData }) => {
  const [expanded, setExpanded] = useState(
    FIELDS.some(f => (formData[f.key] || 0) > 0) || !!formData.dietaryOther
  );

  const total = FIELDS.reduce((sum, f) => sum + (parseInt(formData[f.key]) || 0), 0);

  return (
    <div className="border-b pb-4">
      <button
        type="button"
        onClick={() => setExpanded(!expanded)}
        data-testid="dietary-section-toggle"
        className="flex items-center justify-between w-full text-left"
      >
        <h3 className="font-semibold text-[#1e3a5f] flex items-center gap-2">
          <Utensils size={16} /> Dietary Requirements
          {total > 0 && (
            <span className="text-xs bg-[#c9a227] text-[#1e3a5f] px-2 py-0.5 rounded-full font-bold">
              {total} guests
            </span>
          )}
        </h3>
        {expanded ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
      </button>

      {expanded && (
        <div className="mt-3">
          <p className="text-xs text-gray-500 mb-3">
            Enter the number of guests with each dietary requirement. Kitchen will see a daily roll-up on the BEO.
          </p>
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
            {FIELDS.map(f => (
              <div key={f.key}>
                <Label htmlFor={f.key} className="text-xs">{f.label}</Label>
                <Input
                  id={f.key}
                  type="number"
                  min="0"
                  data-testid={`${f.key}-input`}
                  value={formData[f.key] ?? 0}
                  onChange={(e) => setFormData({ ...formData, [f.key]: e.target.value })}
                  className="h-9"
                />
              </div>
            ))}
          </div>
          <div className="mt-3">
            <Label htmlFor="dietaryOther" className="text-xs">Other / Notes</Label>
            <Textarea
              id="dietaryOther"
              data-testid="dietary-other-input"
              value={formData.dietaryOther || ''}
              onChange={(e) => setFormData({ ...formData, dietaryOther: e.target.value })}
              rows={2}
              placeholder="e.g., 2 shellfish allergies (table 5), 1 low-sodium"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DietarySection;
